import { combineReducers } from "redux";
import { plantsReducer} from "./plantsReducers";
import { vinsReducer} from "./vinsReducers";

const reducers = combineReducers({
    allPlants: plantsReducer,
    allVins: vinsReducer,
    // filterVins: filterVinsReducer,
  });
  export default reducers;